import { buildBusinessErrorFromError, } from '@mgdis/eu-domain';
class AccountManagementRestAdapter {
    restHttpAdapter;
    tenantId;
    /**
     * API of Account Management.
     */
    constructor({ tenantId, restHttpAdapter }) {
        this.tenantId = tenantId;
        this.restHttpAdapter = restHttpAdapter;
    }
    /**
     * Returns account-management public settings
     */
    async getAccountManagementPublicSettings() {
        try {
            const res = await this.restHttpAdapter.get(`/account-management/admin/tenants/${this.tenantId}-demandeurs/publicSettings`);
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error) };
        }
    }
}
export { AccountManagementRestAdapter };
//# sourceMappingURL=account-management-rest.adapter.js.map